import { CoreBeliefKeyType } from "api/conceptApi";
import { Instruction, InstructionWithContent } from "../BlockComponent";
import { MyWorryLines } from "./common";
import {
  BeliefTemplate,
  ResetImpactLevel,
  StreamOfThoughtsTemplate,
  ThoughtRecordLastCard,
  ThoughtRecordTemplate,
  ThoughtRecordUpgradeTemplateCommon,
} from "./thoughtRecord";

export const Content_2_2_T = [
  InstructionWithContent("initial_typography_0_0_0", MyWorryLines()),
  Instruction("initial_typography_1_0_0"),
  ...ThoughtRecordTemplate,
  Instruction("initial_typography_2_0_0"),
  Instruction("initial_typography_3_0_0"),
  Instruction("initial_typography_4_0_0"),
  Instruction("initial_typography_5_0_0"),
  Instruction("initial_typography_6_0_0"),
  Instruction("initial_typography_7_0_0"),
  Instruction("initial_typography_8_0_0"),
  Instruction("initial_typography_9_0_0"),
  ...ThoughtRecordLastCard,
];

export const ThoughtRecordUpgradeTemplate_1 = (
  thoughtTrapNumList: string[]
) => [
  ...ThoughtRecordUpgradeTemplateCommon(1, thoughtTrapNumList),
  ...ResetImpactLevel,
];
export const ThoughtRecordUpgradeTemplate_2 = (
  thoughtTrapNumList: string[]
) => [
  ...ThoughtRecordUpgradeTemplateCommon(2, thoughtTrapNumList),
  ...StreamOfThoughtsTemplate(2),
  ...ResetImpactLevel,
];

export const ThoughtRecordUpgradeTemplate_3 = (
  thoughtTrapNumList: string[],
  coreBeliefKeyList?: CoreBeliefKeyType[]
) => [
  ...ThoughtRecordUpgradeTemplateCommon(3, thoughtTrapNumList),
  ...StreamOfThoughtsTemplate(3),
  ...BeliefTemplate(coreBeliefKeyList),
  ...ResetImpactLevel,
];

export const ThoughtRecordTemplate_U0 = [
  ...ThoughtRecordTemplate,
  ...ThoughtRecordLastCard,
];

export const ThoughtRecordTemplate_U1 = (thoughtTrapNumList: string[]) => [
  ...ThoughtRecordTemplate,
  ...ThoughtRecordUpgradeTemplate_1(thoughtTrapNumList),
  ...ThoughtRecordLastCard,
];

export const ThoughtRecordTemplate_U2 = (thoughtTrapNumList: string[]) => [
  ...ThoughtRecordTemplate,
  ...ThoughtRecordUpgradeTemplate_2(thoughtTrapNumList),
  ...ThoughtRecordLastCard,
];

export const ThoughtRecordTemplate_U3 = (
  thoughtTrapNumList: string[],
  coreBeliefKeyList?: CoreBeliefKeyType[]
) => [
  ...ThoughtRecordTemplate,
  ...ThoughtRecordUpgradeTemplate_3(thoughtTrapNumList, coreBeliefKeyList),
  ...ThoughtRecordLastCard,
];
